module.exports = __webpack_public_path__ + "resources/img/node_js.png";


//////////////////
// WEBPACK FOOTER
// ./src/resources/img/node_js.png
// module id = 1109
// module chunks = 0